const DASHBOARD_PREFIX = '/dashboard'

export default defineNuxtRouteMiddleware((to, from) => {
  // App build only (Capacitor). Web/PWA ships every route, so no-op there.
  if (import.meta.server) return
  if (useRuntimeConfig().public.target !== 'app') return

  // In-webview the app bundles only the /dashboard SPA (+ the / shell) — allow
  // those. Dir-boundary match so `/dashboardxyz` isn't treated as in-app.
  if (to.path === '/' || to.path === DASHBOARD_PREFIX || to.path.startsWith(`${DASHBOARD_PREFIX}/`)) return

  // Everything else (funnels, verticals, marketing) is stripped from the app
  // build (see the `isApp` filter in nuxt.config.ts `pages:extend`), so an
  // in-webview nav would 404. Open it in the external system browser instead.
  // prependHostIfNeeded() makes the URL absolute on native so openInBrowser()
  // uses InAppBrowser.openInSystemBrowser (with auth appended) rather than an
  // in-webview router.push. This also catches backend/CMS-driven paths that
  // reach the router via handleCoreAction / handleCrossSellAction / relative
  // openInBrowser.
  void openInBrowser(prependHostIfNeeded(to.fullPath))

  // Normal nav: cancel it (the external browser handles it now). First nav
  // (cold start / deep link) has no rendered page to stay on, so send the
  // webview to the dashboard instead of leaving a blank abort.
  return from.matched.length ? abortNavigation() : navigateTo(DASHBOARD_PREFIX)
})
